module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.079ca05d.ttf";